import { RootState } from '@modules/App/redux/store';
import { AsyncData } from '@shared/interfaces/asyncData';
import { MyTeamEvalData } from '@modules/EvaluationModule/interfaces/MyTeamEvalData';
import { LocationOptionData } from '@shared/interfaces/LocationOptionData';
import { UserInfo } from '@shared/interfaces/UserInfo';
import { DataState } from '@shared/enums/DataState';
import { SortInfo } from '@shared/interfaces/sortInfo';

export const selectMyPeopleEvalData = (state: RootState): AsyncData<MyTeamEvalData[]> =>
  state.evaluation.myPeopleEvalPage.myPeopleEvalData;

export const selectLocations = (state: RootState): LocationOptionData[] | null =>
  state.evaluation.myPeopleEvalPage.locations.data;

export const selectManagersData = (state: RootState): UserInfo[] | null =>
  state.evaluation.myPeopleEvalPage.managersData.data;

export const selectMembersData = (state: RootState): UserInfo[] | null =>
  state.evaluation.myPeopleEvalPage.membersData.data;

export const selectManagersState = (state: RootState): DataState =>
  state.evaluation.myPeopleEvalPage.managersData.state;

export const selectMembersState = (state: RootState): DataState => state.evaluation.myPeopleEvalPage.membersData.state;

export const selectSortInfo = (state: RootState): SortInfo | null => state.evaluation.myPeopleEvalPage.sortInfo;

export const selectMyPeopleEvalTotal = (state: RootState): number | null =>
  state.evaluation.myPeopleEvalPage.myPeopleEvalTotal;
